import chnu from "../images/chnu.png";
import atlassian from "../images/atlassian.jpg";
import github from "../images/github.jpg";
import docker from "../images/docker.jpg";
import microsoft from "../images/microsoft.jpg";
import pagerduty from "../images/pagerduty.jpg";
import microsoft_system from "../images/microsoft_system.jpg";
import service_now from "../images/service_now.jpg";
import java_certificate from "../images/java_certificate.jpg";
import github_copilot from "../images/github_copilot.jpg";
import microsoft_ai from "../images/microsoft_ai.jpg";
import mozilla_cert from "../images/mozilla_cert.jpg";

export const Bio = {
  name: "Valentyn Arkho",
  headline: "Senior Software Engineer",
  roles: [
    "Senior Software Engineer",
    "Distributed Systems Engineer",
    "Real-Time Collaboration Platform Builder",
    "Digital Infrastructure Engineer",
  ],
  description: [
    "I am a Senior Software Engineer specializing in distributed systems architecture, real-time collaboration platforms, and scalable digital infrastructure.",
    "My work focuses on designing and implementing software systems that improve reliability, coordination, and workflow efficiency in modern engineering environments.",
    "I have experience building and modernizing enterprise-scale web platforms, backend services, and high-traffic digital systems, and I am also the creator of StoryPoker, a production-oriented SaaS collaboration platform for distributed software engineering teams."
  ],
  github: "https://github.com/valentyn-arkho/",
  linkedin: "https://www.linkedin.com/in/valentyn-arkho/",
  email: "mailto:archo.valentyn@gmail.com",
  portfolio: "https://valentynarkho.com/",
  storyPokerLive: "https://storypoker.online/",
  storyPokerDocs: "https://github.com/valentyn-arkho/storypoker-docs",
  cv: "/Valentyn_Arkho_NIW_CV.pdf",
};

export const featuredProject = {
  title: "StoryPoker — Real-Time Agile Estimation Platform",
  subtitle:
    "A production-oriented SaaS collaboration platform designed to support synchronized estimation workflows, shared session state, and real-time coordination for distributed software engineering teams.",
  links: {
    live: "https://storypoker.online/",
    docs: "https://github.com/valentyn-arkho/storypoker-docs",
    github: "https://github.com/valentyn-arkho",
  },
  highlights: [
    "React + TypeScript frontend",
    "GraphQL API and WebSocket-based real-time communication",
    "Node.js backend collaboration service",
    "MongoDB persistence layer",
    "Shared synchronized session state for multiple participants",
    "Browser-based workflow for distributed engineering teams",
  ],
};

export const experience = [
  {
    id: 0,
    company: "Expedia Group",
    role: "Software Development Engineer III",
    date: "Present",
    summary:
      "Contributing to large-scale digital platforms and production systems supporting modern web-based experiences and high-volume user workflows.",
    bullets: [
      "Design and implement scalable software solutions for enterprise web platforms.",
      "Contribute to frontend and backend architecture, system reliability, and cross-functional delivery.",
      "Support production-grade engineering standards, maintainability, and performance optimization.",
    ],
  },
  {
    id: 1,
    company: "SoftServe Inc.",
    role: "Senior Software Engineer / Technical Lead",
    date: "Previous",
    summary:
      "Led and contributed to high-impact engineering work for the Vrbo platform within Expedia Group.",
    bullets: [
      "Worked across React, JavaScript, TypeScript, Java, Kotlin, Node.js, and GraphQL systems.",
      "Served as a technical leader and core reviewer for production engineering work and technical interviews.",
      "Contributed to scalable frontend and backend services supporting real-world user traffic and business workflows.",
    ],
  },
  {
    id: 2,
    company: "SoftServe Inc.",
    role: "Intermediate / Junior Software Engineer",
    date: "Previous",
    summary:
      "Built core engineering experience through production development, testing, documentation, and platform support.",
    bullets: [
      "Implemented frontend and backend features across enterprise software projects.",
      "Contributed to unit, integration, end-to-end, and performance testing practices.",
      "Authored technical documentation and supported production stability workflows.",
    ],
  },
];

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React JS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Webpack",
        image:
          "https://raw.githubusercontent.com/webpack/media/master/logo/icon-square-big.png",
      },
      {
        name: "Babel",
        image:
          "https://d33wubrfki0l68.cloudfront.net/377d727c8d878832f20e08939889a58bdff0b3f2/63787/img/babel.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
      },
      {
        name: "Gatsby",
        image: "https://www.vectorlogo.zone/logos/gatsbyjs/gatsbyjs-icon.svg",
      },
      {
        name: "CSS",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        name: "SCSS",
        image: "https://sass-lang.com/assets/img/styleguide/seal-color.png",
      },
      {
        name: "LESS",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-less-18-1175145.png?f=webp",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Jest",
        image: "https://www.vectorlogo.zone/logos/jestjsio/jestjsio-icon.svg",
      },
      {
        name: "Mocha",
        image:
          "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20192%20191.99999%22%20width%3D%22192%22%20height%3D%22192%22%3E%3Cpath%20d%3D%22M169.47386%20143.90113l-68.70282%2039.69498c-2.958045%201.71756-6.584028%201.71756-9.542066%200L22.52614%20143.90113c-2.958038-1.71757-4.77103-4.86645-4.77103-8.20617V56.305021c0-3.435142%201.812992-6.488601%204.77103-8.206172L91.228974%208.403878c2.958038-1.717571%206.584021-1.717571%209.542056%200l68.70282%2039.694971c2.95804%201.717571%204.77104%204.866451%204.77104%208.206172v79.389939c-.0954%203.33972-1.90842%206.4886-4.77104%208.20617z%22%20clip-rule%3D%22evenodd%22%20fill%3D%22%238d6748%22%20fill-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M95.904583%2022.049024c.954207%200%201.812992.286262%202.671781.763365l59.351606%2034.255996c1.62216.954206%202.67177%202.767198%202.67177%204.67561v68.511985c0%201.90842-1.04962%203.72141-2.67177%204.67562l-59.351606%2034.25599c-.858789.47711-1.717574.76336-2.671781.76336-.954206%200-1.908412-.28625-2.671777-.76336L33.881192%20134.9316c-1.62215-.95421-2.671778-2.7672-2.671778-4.67562V61.743995c0-1.908412%201.049628-3.721404%202.671778-4.67561l59.351614-34.255996c.858785-.477103%201.812992-.763365%202.671777-.763365m0-2.862618c-1.431309%200-2.862618.381683-4.103085%201.145048L32.449883%2054.58745c-2.576357%201.431309-4.103086%204.198506-4.103086%207.061124v68.511996c0%202.95803%201.526729%205.62981%204.103086%207.06112l59.351615%2034.25599c1.240467.76337%202.671776%201.14506%204.103085%201.14506%201.431309%200%202.862617-.38169%204.103097-1.14506l59.35159-34.25599c2.57636-1.43131%204.10309-4.1985%204.10309-7.06112V61.648574c0-2.958038-1.52673-5.629815-4.10309-7.061124l-59.35159-34.255996c-1.24048-.763365-2.671788-1.145048-4.103097-1.145048z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20d%3D%22M104.3493%2061.648574c0-.477103-.381682-.954206-.954206-.954206H85.456021c-.477103%200-.954206.381682-.954206.954206%200%203.2443.477103%2014.40851%205.248133%2019.847485.190841.190841.381683.286262.667944.286262h8.01533c.286263%200%20.477104-.09542.667945-.286262%204.77103-5.343554%205.248133-16.507764%205.248133-19.847485zm-7.061124%2017.36655H91.65836c-.286262%200-.477103-.095421-.667944-.286263-3.2443-3.816824-3.625983-11.450472-3.721403-14.122249%200-.477103.381682-.954206.954206-.954206h12.595519c.477103%200%20.954206.381683.954206.954206%200%202.671777-.477103%2010.210005-3.721403%2014.12225-.286262.19084-.477103.286261-.763365.286261zM96.23855%2058.785956s3.43514-2.003833%201.335888-5.629816c-1.240468-1.908412-1.812992-3.530562-1.335889-4.198506-1.240468%201.52673-3.339721%203.14888-1.049627%206.584021.763365.858786%201.145048%202.671777%201.049627%203.2443zM92.421725%2059.072217s2.290094-1.335888.858785-3.816824c-.858785-1.240467-1.240467-2.385515-.858785-2.767197-.858785%201.049627-2.194674%202.099253-.667944%204.484768.477103.477103.667944%201.717571.667944%202.099253z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20d%3D%22M100.246214%2070.141007c-.381682%202.576357-1.145047%205.534395-2.767197%207.442807-.190841.190841-.381682.286262-.572524.286262h-4.77103c-.190841%200-.477103-.09542-.572523-.286262-1.145048-1.431309-1.908412-3.33972-2.385515-5.343553%200%200%205.534394.763364%208.683274-.381683%202.290095-.858785%202.385515-1.71757%202.385515-1.71757z%22%20fill%3D%22%23fff%22%2F%3E%3Cg%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M37.554879%2085.599145h3.530562l5.820657%208.969536%205.820657-8.969536h3.530562v19.08412h-3.339721V91.03812l-6.011498%208.969537h-.09542L40.8946%2091.13354v13.645146h-3.339721V85.599145zM73.528446%20104.969527c-1.43131%200-2.767198-.286262-4.007665-.763365-1.240468-.477103-2.290095-1.240468-3.14888-2.099253-.858786-.858785-1.52673-1.908412-2.003833-3.14888-.477103-1.145047-.763365-2.480936-.763365-3.816824v-.09542c0-1.335889.286262-2.576357.763365-3.816825.477103-1.145047%201.145047-2.194674%202.099253-3.14888.858786-.858785%201.908412-1.62215%203.14888-2.099253%201.240468-.572523%202.576356-.763365%204.007665-.763365%201.43131%200%202.767198.286262%204.007666.763365%201.240468.477103%202.290094%201.240468%203.14888%202.099253.858785.858786%201.52673%201.908412%202.003832%203.14888.477103%201.145048.763365%202.480936.763365%203.816824v.095421c0%201.335888-.286262%202.576356-.763365%203.816824-.477103%201.145047-1.145047%202.194674-2.099253%203.14888-.858785.858785-1.908412%201.62215-3.14888%202.099253-1.240468.572524-2.576356.763365-4.007665.763365zm0-3.05346c.954206%200%201.812991-.19084%202.576356-.572523.763365-.381682%201.43131-.858785%202.003833-1.431309.572523-.572524.954206-1.335888%201.335888-2.099253.286262-.858786.477103-1.717571.477103-2.576356v-.095421c0-.954206-.190841-1.812991-.477103-2.671777-.286262-.858785-.763365-1.52673-1.335888-2.194674-.572524-.572523-1.240468-1.049626-2.003833-1.431309-.763365-.381682-1.62215-.572523-2.576356-.572523-.954206%200-1.812992.19084-2.576356.572523-.763365.381683-1.43131.858786-2.003833%201.43131-.572524.572523-.954206%201.335888-1.335888%202.099253-.286262.858785-.477104%201.71757-.477104%202.576356v.09542c0%20.954206.190842%201.812992.477104%202.671777.286261.858786.763364%201.52673%201.335888%202.194674.572524.572524%201.240468%201.049627%202.003833%201.43131.763364.381682%201.71757.572523%202.576356.572523zM99.67369%20104.969527c-1.431308%200-2.671776-.286262-3.816823-.763365-1.145048-.477103-2.194674-1.240468-3.05346-2.099253-.858785-.858785-1.52673-1.908412-2.003832-3.14888-.477103-1.240468-.763365-2.480936-.763365-3.816824v-.09542c0-1.335889.286262-2.671777.763365-3.816825.477103-1.145047%201.145047-2.194674%202.003832-3.14888.858786-.858785%201.908412-1.62215%203.14888-2.099253%201.240468-.477103%202.480936-.763365%204.007666-.763365.858785%200%201.62215.095421%202.385515.190842.763364.19084%201.335888.381682%202.003832.572523.572524.286262%201.145047.572524%201.62215.954206.477104.381683.954207.763365%201.43131%201.240468l-2.194674%202.480936c-.763365-.667945-1.52673-1.240468-2.385515-1.717571-.858786-.477103-1.812992-.667944-2.958039-.667944-.954206%200-1.71757.19084-2.480936.572523-.763364.381683-1.431309.858786-2.003832%201.43131-.572524.572523-.954206%201.335888-1.335889%202.099253-.286262.858785-.477103%201.71757-.477103%202.576356v.09542c0%20.954206.190841%201.812992.477103%202.671777.286262.858786.763365%201.52673%201.335889%202.194674.572523.572524%201.240468%201.145047%202.003832%201.43131.763365.28626%201.62215.572523%202.480936.572523%201.145047%200%202.194674-.190841%202.958039-.667944.763364-.477103%201.62215-1.049627%202.480935-1.812992l2.194674%202.194674c-.477103.572524-.954206.954206-1.52673%201.431309-.572523.477103-1.145047.763365-1.71757%201.049627-.572524.286261-1.335889.572523-2.003833.667944-.858785.190841-1.71757.190841-2.576356.190841zM114.177622%2085.599145h3.339721v7.91991h9.160378v-7.91991h3.339721v19.08412h-3.33972v-8.01533h-9.160379v8.01533h-3.33972v-19.08412zM144.807636%2085.503724h3.053459l8.397013%2019.179541h-3.530563l-1.908412-4.580189h-8.969536l-2.003833%204.58019h-3.435141l8.397013-19.179542zm4.77103%2011.641314l-3.2443-7.633649-3.244301%207.633649h6.4886z%22%2F%3E%3C%2Fg%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M35.169365%20110.69476h121.66127v1.049627H35.169365zM156.83062%2074.816618h-51.71797c0%20.381682-.0954.667943-.0954%201.049626h51.81338v-1.049626zM35.169364%2074.816618v1.049626h48.759928c0-.381683-.09542-.667944-.09542-1.049626H35.169365z%22%2F%3E%3C%2Fsvg%3E"
      },
      {
        name: "Cypress",
        image:
          "https://raw.githubusercontent.com/ijsto/cypress-snippets/master/images/logo.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node JS", image: "https://nodejs.org/static/images/logo.svg" },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Express JS",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "GraphQL",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Infrastructure & Tools",
    skills: [
      {
        name: "AWS",
        image:
          "https://ih1.redbubble.net/image.4713585318.4961/st,small,507x507-pad,600x600,f8f8f8.jpg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image: "https://www.vectorlogo.zone/logos/jenkins/jenkins-icon.svg",
      },
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Postman",
        image: "https://cdn.worldvectorlogo.com/logos/postman.svg",
      },
      {
        name: "VS Code",
        image:
          "https://code.visualstudio.com/assets/branding/code-stable.png",
      },
    ],
  },
];

export const education = [
  {
    id: 0,
    img: chnu,
    school: "Yuriy Fedkovych Chernivtsi National University, Ukraine",
    date: "Sep 2020 - Dec 2021",
    desc: "Completed a Master’s degree in Software Engineering with academic training in software development, software system reengineering, and applied engineering methodologies.",
    degree: 'Master’s Degree — Software Engineering',
  },
  {
    id: 1,
    img: chnu,
    school: "Yuriy Fedkovych Chernivtsi National University, Ukraine",
    date: "Sep 2016 - Jun 2020",
    desc: "Completed a Bachelor’s degree in Software Engineering with foundational training in programming, software design, systems development, and technical problem solving.",
    degree: 'Bachelor’s Degree — Software Engineering',
  },
];

export const professionalCertificates = [
  {
    id: 0,
    title: "JavaScript Foundations Professional Certificate by Mozilla",
    date: "Dec 2025",
    image: mozilla_cert,
    tags: ["Web Development", "JavaScript"],
    link: "https://www.linkedin.com/learning/certificates/8b9f947fcf650191a561bb589271aa6e11cfca7de63561899c2fb9598310212e",
  },
  {
    id: 1,
    title: "Java Foundations Professional Certificate by JetBrains",
    date: "Dec 2025",
    image: java_certificate,
    tags: ["Java", "Data Structures", "Object-Oriented Programming (OOP)"],
    link: "https://www.linkedin.com/learning/certificates/229dba74eb34aab2dd521524b7f0a6fd1c7849d651b327da27fd75351b2d19ac",
  },
  {
    id: 2,
    title: "Career Essentials in GitHub Copilot Professional Certificate",
    date: "Nov 2025",
    image: github_copilot,
    tags: ["GitHub Copilot", "AI Productivity"],
    link: "https://www.linkedin.com/learning/certificates/86117492ffdca2d6ee1fdabf58f33e11977745ecc93f3f830ecf40e1ef94e5af",
  },
  {
    id: 3,
    title: "Career Essentials in Generative AI by Microsoft and LinkedIn",
    date: "Nov 2025",
    image: microsoft_ai,
    tags: ["Microsoft Copilot", "Generative AI"],
    link: "https://www.linkedin.com/learning/certificates/c53e92a1eefb489f9c16274ed02408e9d845325928ab773737ffaa7a1fed1e7f",
  },
  {
    id: 4,
    title: "Career Essentials in Software Development by Microsoft and LinkedIn",
    date: "Jan 2024",
    image: microsoft,
    tags: ["Programming", "Software Development"],
    link: "https://www.linkedin.com/learning/certificates/cda98c63b1fbde310d0c3392623aaa09d2de8898870d1ea9f0e0de9ba285fadd?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BCzKY2MyPQqi5c6PXp%2B6wvQ%3D%3D",
  },
  {
    id: 5,
    title: "Atlassian Agile Project Management Professional Certificate",
    date: "Jan 2024",
    image: atlassian,
    tags: ["Jira", "Agile Methodologies", "Agile Project Management"],
    link: "https://www.linkedin.com/learning/certificates/92ca1b98f50b73d29e8a6d25b278ce2e1c711602ea13e822f3aff7b36d26e983",
  },
  {
    id: 6,
    title: "Career Essentials in GitHub Professional Certificate",
    date: "Jan 2024",
    image: github,
    tags: ["GitHub"],
    link: "https://www.linkedin.com/learning/certificates/fd8ddb8700b84218b9ddfea226c4cebfceba85ce3bcdbf871833cf51c4eaed7c",
  },
  {
    id: 7,
    title: "Docker Foundations Professional Certificate",
    date: "May 2024",
    image: docker,
    tags: ["Docker Products", "Containerization"],
    link: "https://www.linkedin.com/learning/certificates/05c0ecdb7860a56d4579ca344135b262e1fd58da11781d37322870003dbc569d",
  },
  {
    id: 8,
    title: "DevOps Professional Certificate by PagerDuty and LinkedIn",
    date: "May 2024",
    image: pagerduty,
    tags: ["DevOps", "CI/CD", "Infrastructure as code (IaC)"],
    link: "https://www.linkedin.com/learning/certificates/2b9bed0e46352b2636d12894c5cd8292ccc77d91347d8cb81d362d1466935a51",
  },
  {
    id: 9,
    title: "ServiceNow IT Leadership Professional Certificate",
    date: "May 2024",
    image: service_now,
    tags: ["IT Strategic Planning", "IT Project & Program Management"],
    link: "https://www.linkedin.com/learning/certificates/f7fb23dd339be5eea63bb9a14a1bed4f51a59bd03f7b1e30286d0f3a9b36921c",
  },
  {
    id: 10,
    title: "Career Essentials in System Administration by Microsoft and LinkedIn",
    date: "May 2024",
    image: microsoft_system,
    tags: ["System Administration", "Network Security"],
    link: "https://www.linkedin.com/learning/certificates/5d79c2036f317215b85e1e7ff229e445d92fa2dbd3ea18861473bd1469fb88b0",
  },
];

export const certificates = [
  {
    id: 0,
    title: "Learning Full-Stack JavaScript Development: MongoDB, Node, and React",
    date: "Jan 2024",
    description:
      "Learn full-stack JavaScript development by building a web application with MongoDB, Node.js, and React.js.",
    image: "https://www.revenueriver.co/hubfs/fullstack.jpeg",
    tags: ["React JS", "MongoDB", "Node JS", "Express JS"],
    category: "frontend",
    link: "https://www.linkedin.com/learning/certificates/4f2deb3f7bda228705c502f5d6feabdd7cc72457142281a85f42ceebe46e5041",
  },
  {
    id: 1,
    title: "Redux with React JS: Learn Redux with Modern React JS",
    date: "Dec 2023",
    description:
      "Learn Redux, React Router, and React Portals while building modern React applications.",
    image: "https://img-c.udemycdn.com/course/750x422/2645112_aaa2_15.jpg",
    tags: ["React JS", "React Router", "React Portals", "Redux", "HTML", "CSS", "JavaScript"],
    category: "frontend",
    link: "https://www.udemy.com/certificate/UC-6d45820b-bdc1-42c2-8ea1-b682bc19fb41/",
  },
  {
    id: 2,
    title: "Leadership: Practical Leadership Skills",
    date: "Dec 2023",
    description:
      "Practical training in leadership techniques, communication, and team effectiveness.",
    image: "https://img-c.udemycdn.com/course/480x270/613808_3c1c_6.jpg",
    tags: ["Leadership", "Communication"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-3c85e95b-7db9-4c5a-9a71-c81fe3d4f3ec/",
  },
  {
    id: 3,
    title: "Agile Leadership: Become An Agile Leader",
    date: "Dec 2023",
    description:
      "Focused on agile leadership, team collaboration, and organizational effectiveness.",
    image: "https://img-c.udemycdn.com/course/750x422/4248744_78e9_3.jpg",
    tags: ["Agile", "Leadership", "Handling Conflicts", "Collaboration"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-77fe5b57-daa8-494f-aca2-feb2332fafa7/",
  },
  {
    id: 4,
    title: "Clean Code",
    date: "Dec 2023",
    description:
      "Focused on writing readable, maintainable, and well-structured software.",
    image: "https://img-c.udemycdn.com/course/750x422/3611296_bcb5_6.jpg",
    tags: ["Naming", "Patterns", "Methods", "Variables", "Classes", "Formatting"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-c91377fe-6617-471d-ae33-b52847648fcd/",
  },
  {
    id: 5,
    title: "Communication Skills: Become Clear, Concise, Confident",
    date: "Dec 2023",
    description:
      "Focused on communication clarity, confidence, and persuasive professional speaking.",
    image: "https://img-c.udemycdn.com/course/750x422/2129860_4d0b_3.jpg",
    tags: ["Communication", "English"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-a4f7d166-e9ee-474c-9697-3cc2418e5221/",
  },
  {
    id: 6,
    title: "English Language Pro | Spoken English Conversation + Culture",
    date: "Dec 2023",
    description:
      "Focused on practical English fluency, business communication, and spoken confidence.",
    image: "https://img-c.udemycdn.com/course/480x270/2182660_4325_8.jpg",
    tags: ["English", "Business English", "Communication"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-d2b10aab-bd84-4029-b702-50735a9ccb5e/",
  },
  {
    id: 7,
    title: "Software Architecture & Design of Modern Large Scale Systems",
    date: "Mar 2023",
    description:
      "Focused on software architecture, system design, patterns, APIs, and large-scale systems thinking.",
    image: "https://img-c.udemycdn.com/course/480x270/3997622_0670_2.jpg",
    tags: ["Software Architecture", "System Design", "Patterns", "API", "Big Data Processing"],
    category: "other",
    link: "https://www.udemy.com/certificate/UC-b4985e1a-3e0b-408d-94d3-32935da209cc/",
  },
];
